
import {IRiskInfo} from "./risk-info.interface";

export class ExtendedRiskInfo implements IRiskInfo{
  id: string;
  index: number;
  private _name: string;
  description: string;
  examples: string;
  examplesSummary: string;
  operativeTypeId: string;
  isSelected: boolean;

  constructor(iRiskInfo: IRiskInfo = null){
    this.id = iRiskInfo?.id ?? "";
    this.index = iRiskInfo?.index ?? 0;
    this._name = iRiskInfo?.name ?? "";
    this.description = iRiskInfo?.description ?? "";
    this.examples = iRiskInfo?.examples ?? "";
    this.examplesSummary = iRiskInfo?.examplesSummary ?? "";
    this.operativeTypeId = iRiskInfo?.operativeTypeId ?? "";

    this.isSelected = iRiskInfo?.isSelected ?? false;
  }

  get name(): string{
    return this._name + ' - (' + this.examplesSummary.trim() + ')';
  }

  get basicName(): string{
    return this._name;
  }

}
